import "../../../../css/modal/UserDetailsModal.css"
import "../../../../css/modal/ModalInput.css"
import UserListInfo from "../../../../utils/UserListInfo";
import LocationCode from "../../../../utils/constants/LocationCode";
import FunnelCode from "../../../../utils/constants/FunnelCode";
import Gender from "../../../../utils/constants/Gender";
import { getDateString, limitInputNumber, setInvalidMessage, checkValidDateWithPattern, moveModal } from "../../../../utils/Utils";
import { useRef, useState } from "react";
import proxy from "../../../../utils/Proxy";

let UserEditModal = (props) => {
    let ref = useRef(null)
    let [validBirth, setValidBirth] = useState(true)
    let [submitted, setSubmitted] = useState(false)

    let data = {}
    for (let name of UserListInfo.detailDataName)
        data[name] = props.data[name]

    data["location"] = LocationCode.text[data["location"]]
    data["birth"] = getDateString(new Date(data["birth"]))
    data["birth-year"] = data["birth"].slice(0, 4)
    data["birth-month"] = data["birth"].slice(5, 7)
    data["birth-day"] = data["birth"].slice(8, 10)
    data["howto"] = FunnelCode.text[data["howto"]]
    data["registration"] = getDateString(new Date(data["registration"]))
    data["register_start_date"] = getDateString(new Date(data["register_start_date"]))
    data["register_end_date"] = getDateString(new Date(data["register_end_date"]))

    let checkValidBirth = () => {
        let valid = checkValidDateWithPattern("user-edit-input-birth-year", "user-edit-input-birth-month", "user-edit-input-birth-day")
        setValidBirth(valid)

        if (!valid) {
            document.getElementById("user-edit-invalid-message-birth").innerHTML = UserListInfo.InvalidMessage[2];
            return false;
        }
        else {
            document.getElementById("user-edit-invalid-message-birth").innerHTML = "";
            return true;
        }
    }

    let onChangeBirth = (e, limit) => {
        limitInputNumber(e, limit);
        checkValidBirth();
    }

    let saveUserInfo = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (!dialogResult) return;

        setSubmitted(true);
        // valid check
        let invalidList = []
        for (let i = 0; i < UserListInfo.notEditableDetailIndexStart; i++) {
            let name = UserListInfo.detailDataName[i];
            if (name === "location" || name === "howto" || name === "gender" || name === "subscribed") continue;

            if (name === "birth") {
                if (!checkValidBirth()) invalidList.push(UserListInfo.detailLabel[i]);
                continue;
            }

            let validityTarget = document.getElementById("user-edit-input-" + name)
            let valid = validityTarget.validity.valid;
            if (!valid) invalidList.push(UserListInfo.detailLabel[i]);
            setInvalidMessage(validityTarget, "user-edit-invalid-message-" + name, UserListInfo.InvalidMessage[i])
        }
        if (invalidList.length > 0) {
            let message = "";
            for (let invalid of invalidList)
                message += invalid + ", ";
            message = message.slice(0, -2)

            window.alert("잘못된 형식입니다.\n(" + message + ")");

            return;
        }

        // read edit data
        let edit = {};

        for (let i = 0; i < UserListInfo.notEditableDetailIndexStart; i++) {
            let name = UserListInfo.detailDataName[i];
            let keyword = "user-edit-input-" + name;
            switch (name) {
                case "location":
                case "gender":
                case "howto":
                    let radioList = document.getElementsByName(keyword);
                    for (let j = 0; j < radioList.length; j++) {
                        if (radioList[j].checked) {
                            edit[name] = j;
                            break;
                        }
                    }
                    break;
                case "birth":
                    let year = document.getElementById("user-edit-input-birth-year").value
                    let month = document.getElementById("user-edit-input-birth-month").value
                    let day = document.getElementById("user-edit-input-birth-day").value
                    let birth = new Date(year, month - 1, day);
                    edit[name] = getDateString(birth);
                    break;
                case "lesson_count":
                case "lesson_count_used":
                    edit[name] = parseInt(document.getElementById(keyword).value);
                    break;
                case "subscribed":
                    edit[name] = document.getElementById(keyword).checked;
                    break;
                default:
                    edit[name] = document.getElementById(keyword).value;
            }
        }
        let body = {};
        for (let name of UserListInfo.detailDataName) {
            if (name === "birth") continue;
            if (edit[name] !== undefined && props.data[name] !== edit[name]) {
                body[name] = edit[name];
            }
        }
        if (edit["birth"] !== getDateString(new Date(props.data["birth"]))) {
            body["birth"] = edit["birth"]
        }
        proxy.put("/adminapi/users/" + props.data.userid, body).then(() => {
            window.alert("정보가 수정되었습니다.");
            props.onCloseClick(props.data.userid);
        }).catch(res => window.alert(res.response.data.message));
    }

    let cancelEditUserInfo = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult)
            props.onCloseClick()
    }

    return (
        <div className="modal-container">
            <div className="modal" id="user-details-modal" ref={ref}>
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={(e) => moveModal(e, "user-details-modal")}>
                        <p className="modal-title">
                            수강생 정보 수정
                        </p>
                        <div className="modal-close-button" onClick={cancelEditUserInfo}></div>
                    </div>
                    <div className="modal-content">
                        <div className="modal-content-items-container">
                            {UserListInfo.detailLabel.map((label, index) => {
                                let input = <></>

                                switch (label) {
                                    case "수강 지점":
                                        input = (
                                            <div className="modal-input-radio-container">
                                                {LocationCode.text.map((location, index) => {
                                                    let defaultChecked = location === data["location"]
                                                    return (
                                                        <label className="modal-input-radio-label" key={"editUserLocation" + index}>
                                                            <input type="radio" name="user-edit-input-location" value={index} defaultChecked={defaultChecked} />
                                                            <p>{location}</p>
                                                        </label>
                                                    )
                                                })}
                                            </div>
                                        )
                                        break;
                                    case "성별":
                                        let male = false;
                                        let female = false;
                                        if (data["gender"] === Gender.female) female = true;
                                        else male = true;
                                        input = (
                                            <div className="modal-input-radio-container">
                                                <label className="modal-input-radio-label">
                                                    <input type="radio" name="user-edit-input-gender" value="0" defaultChecked={male} />
                                                    <p>{Gender.text[0]}</p>
                                                </label>
                                                <label className="modal-input-radio-label">
                                                    <input type="radio" name="user-edit-input-gender" value="1" defaultChecked={female} />
                                                    <p>{Gender.text[1]}</p>
                                                </label>
                                            </div>
                                        )
                                        break;
                                    case "방문경로":
                                        input = (
                                            <div className="modal-input-radio-container">
                                                {FunnelCode.text.map((funnel, index) => {
                                                    let defaultChecked = funnel === data["howto"]
                                                    return (
                                                        <label className="modal-input-radio-label" key={"editUserFunnel" + index}>
                                                            <input type="radio" name="user-edit-input-howto" value={index} defaultChecked={defaultChecked} />
                                                            <p>{funnel}</p>
                                                        </label>
                                                    )
                                                })}
                                            </div>
                                        )
                                        break;
                                    case "문자수신 여부":
                                        input = (
                                            <div className="modal-input-radio-container">
                                                <input type="checkbox" id="user-edit-input-subscribed" defaultChecked={data["subscribed"]}/>
                                            </div>
                                        )
                                        break;
                                    case "생년월일":
                                        input = (
                                            <div className={!submitted || validBirth ?
                                                "modal-input" : "modal-input-invalid"}>
                                                <input className="modal-input-date" id="user-edit-input-birth-year"
                                                    defaultValue={data["birth-year"]} onChange={e => onChangeBirth(e, 4)}
                                                    pattern="\d{4}" required></input>
                                                <p>-</p>
                                                <input className="modal-input-date" id="user-edit-input-birth-month"
                                                    defaultValue={data["birth-month"]} onChange={e => onChangeBirth(e, 2)}
                                                    pattern="0?[1-9]|1[0-2]" required></input>
                                                <p>-</p>
                                                <input className="modal-input-date" id="user-edit-input-birth-day"
                                                    defaultValue={data["birth-day"]} onChange={e => onChangeBirth(e, 2)}
                                                    pattern="0?[1-9]|[1-2][0-9]|3[0-1]" required></input>
                                            </div>
                                        )
                                        break;
                                    case "피아노 경력":
                                    case "희망장르":
                                        input = (
                                            <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                                id={"user-edit-input-" + UserListInfo.detailDataName[index]}
                                                defaultValue={data[UserListInfo.detailDataName[index]]}></input>
                                        )
                                        break;
                                    default:
                                        input = (
                                            <input className={"modal-input" + (submitted ? " modal-input-submitted" : "")}
                                                id={"user-edit-input-" + UserListInfo.detailDataName[index]}
                                                defaultValue={data[UserListInfo.detailDataName[index]]}
                                                onChange={e => { setInvalidMessage(e.target, "user-edit-invalid-message-" + UserListInfo.detailDataName[index], UserListInfo.InvalidMessage[index]) }}
                                                pattern={UserListInfo.detailEditRegex[index]} required></input>
                                        )
                                }
                                if (label === "등록기간") {
                                    if (props.data.isRegister) {
                                        if (props.data.startdate_non_set) {
                                            return (
                                                <div className="modal-content-item modal-content-align-start" key={"detail-modal-" + index}>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{label}</p>
                                                    </div>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">시작일 미정</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        else {
                                            return (
                                                <div className="modal-content-item modal-content-align-start" key={"detail-modal-" + index}>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{label}</p>
                                                    </div>
                                                    <div className="modal-content-divider-2">
                                                        <p className="modal-content-text">{data["register_start_date"]} ~ {data["register_end_date"]}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    }
                                    else {
                                        return (
                                            <div className="modal-content-item modal-content-align-start" key={"detail-modal-" + index}>
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">{label}</p>
                                                </div>
                                                <div className="modal-content-divider-2">
                                                    <p className="modal-content-text">미등록</p>
                                                </div>
                                            </div>
                                        )
                                    }
                                } else if (label === "") return null
                                return (
                                    <div className="modal-content-item modal-content-align-start" key={"detail-modal-" + index}>
                                        <div className="modal-content-divider-2">
                                            <p className="modal-content-text">{label}</p>
                                        </div>
                                        <div className="modal-content-divider-2">
                                            {index >= UserListInfo.notEditableDetailIndexStart ?
                                                <p className="modal-content-text">{data[UserListInfo.detailDataName[index]] + UserListInfo.detailDataFormating[index]}</p> :
                                                <>
                                                    {input}
                                                    <p className="modal-input-invalid-message"
                                                        id={"user-edit-invalid-message-" + UserListInfo.detailDataName[index]}></p>
                                                </>}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={saveUserInfo}>
                                <p>저장</p>
                            </div>
                            <div className="modal-button" onClick={cancelEditUserInfo}>
                                <p>취소</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserEditModal;